<template>
<div class="chapter">
<div class="inner_page">
<div class="chapter" id="cop">
<p class="crt">Copyright © 2010 by The University Press of Kentucky</p>
<p class="crt">Scholarly publisher for the Commonwealth,<br/>serving Bellarmine University, Berea College, Centre<br/>College of Kentucky, Eastern Kentucky University,<br/>The Filson Historical Society, Georgetown College,<br/>Kentucky Historical Society, Kentucky State University,<br/>Morehead State University, Murray State University,<br/>Northern Kentucky University, Transylvania University,<br/>University of Kentucky, University of Louisville,<br/>and Western Kentucky University.<br/>All rights reserved.</p>
<p class="crt"><em>Editorial and Sales Offices:</em> The University Press of Kentucky 663 South Limestone Street, Lexington, Kentucky 40508-4008<br/><a class="hlink" href="http://www.kentuckypress.com" target="_blank">www.kentuckypress.com</a></p>
<p class="crt">14 13 12 11 10     5 4 3 2 1</p>
<p class="crt">Library of Congress Cataloging-in-Publication Data</p>
<p class="crt1">Brown, Roberta Simpson, 1939-</p>
<p class="crt2">Spookiest stories ever: four seasons of Kentucky ghosts / Roberta Simpson Brown and Lonnie E. Brown, foreword by Elizabeth Tucker.</p>
<p class="crt2"> p. cm.</p>
<p class="crt2">ISBN 978-0-8131-2595-4 (hardcover: alk. paper)</p>
<p class="crt2">1. Tales—Kentucky. 2. Ghost stories, American—Kentucky. I. Brown, Lonnie E. II. Tucker, Elizabeth, 1948-III. Title.</p>
<p class="crt2">GR110.K4B76 2010</p>
<p class="crt2">398.209769—dc22</p>
<p class="crt3">2010017533</p>
<p class="crt">This book is printed on acid-free recycled paper meeting the requirements of the American National Standard for Permanence in Paper for Printed Library Materials.</p>
<p class="nonindent">     <img alt="" src="OEBPS/images/IV-1.png"/></p>
<p class="crt">Manufactured in the United States of America.</p>
<p class="crt"><img alt="" src="OEBPS/images/IV-2.png"/> Member of the Association of American University Presses</p>
</div>
</div>
</div>
</template>
<script>

export default {
  name: 'chapter',
  data() {
    return {}
    },
      components: {
    }
  }
</script>



// WEBPACK FOOTER //
// 9780813173894_epub_cop_r1.vue?18bd5f97